import {
  Bot,
  Building2,
  ChartColumnIncreasing,
  ChartLine,
  ClipboardList,
  History,
  House,
  IdCard,
  MessageSquare,
  PanelsTopLeft,
  Scale,
  Search,
  Shield,
  ShieldCheck,
  Trash2,
  TriangleAlert,
  UsersRound,
} from "lucide-react";

const iconsByTool = {
  home: House,
  comparator: Scale,
  "create-user-group": UsersRound,
  "compare-access": PanelsTopLeft,
  "entitlement-lookup": IdCard,
  "access-search": Search,
  "access-request-history": History,
  "security-access-report": ChartColumnIncreasing,
  "security-field-testing": ShieldCheck,
  "visier-security-testing": Shield,
  "servicenow-actions": ClipboardList,
  "sprint-metrics": ChartColumnIncreasing,
  "provisioning-errors": TriangleAlert,
  analytics: ChartLine,
  "ai-agents": Bot,
  "actor-org-unit": Building2,
  "infor-user-purge": Trash2,
  "feedback-inbox": MessageSquare,
};

export default function ToolIcon({ toolId, size = 18 }) {
  const Icon = iconsByTool[toolId] || PanelsTopLeft;
  return <Icon size={size} strokeWidth={1.8} aria-hidden="true" />;
}